import React from "react";
import whatsapp from "../assets/whatsapp.png";
import calculator from "../assets/calculator.png";
import crypto_tracker from "../assets/crypto_tracker.png";
import amazon from "../assets/amazon.png";
import swab_nanosolutions from "../assets/swab_nanosolutions.png";
import param_guru from "../assets/param_guru.png";
import local_farmers from "../assets/local_farmers.png";
import discord from "../assets/discord.png";
import vef_admin from "../assets/vef_admin.png";
import veer_eklavya_foundation from "../assets/veer_eklavya_foundation.png";
import trackvid from "../assets/trackvid.png";
import tictactoe from "../assets/tictactoe.png";
import pet_notch from "../assets/pet_notch.png";
import { FaApple, FaBrush, FaAndroid, FaLaptopCode } from "react-icons/fa";

export const SKILLS = [
  {
    name: "React",
    icon: require("../assets/react.png"),
  },
  {
    name: "Firebase",
    icon: require("../assets/firebase.png"),
  },
  {
    name: "Redux",
    icon: require("../assets/redux.png"),
  },
  {
    name: "Node JS",
    icon: require("../assets/node.png"),
  },
  {
    name: "Javascript",
    icon: require("../assets/javascript.png"),
  },
  {
    name: "Material UI",
    icon: require("../assets/mu5.png"),
  },
  {
    name: "HTML5",
    icon: require("../assets/html.png"),
  },
  {
    name: "CSS3",
    icon: require("../assets/css.png"),
  },

  {
    name: "Figma",
    icon: require("../assets/figma.png"),
  },
  {
    name: "Git",
    icon: require("../assets/git.png"),
  },

  {
    name: "Tailwind Css",
    icon: require("../assets/tailwindcss.png"),
  },
  {
    name: "Bootstrap",
    icon: require("../assets/html.png"),
  },
];

export const EXPERIENCES = [
  {
    year: "2019",
    works: [
      {
        name: "Android Developer Intern",
        company: "Affiminitus Technologies",
        desc: "Modern Android App Architecture Object-oriented programming in Java",
      },
    ],
  },
  {
    year: "2020",
    works: [
      {
        name: "Full Stack Developer",
        company: "The Most Keto",
        desc: "Modern Android App Architecture Object-oriented programming in Java",
      },
    ],
  },
  {
    year: "2021",
    works: [
      {
        name: "React Native Developer",
        company: "HeyHungry (Tesmocat Pvt Ltd.)",
        desc: "Modern Android App Architecture Object-oriented programming in Java",
      },
      {
        name: "Web Developer",
        company: "ParamGuru",
        desc: "Modern Android App Architecture Object-oriented programming in Java",
      },
      {
        name: "Full Stack Developer",
        company: "Veer Eklavya Foundation",
        desc: "Modern Android App Architecture Object-oriented programming in Java",
      },
    ],
  },
  {
    year: "2022",
    works: [
      {
        name: "Frontend Developer",
        company: "LocalFarmers",
        desc: "Modern Android App Architecture Object-oriented programming in Java",
      },
      {
        name: "React Native Developer",
        company: "MyBranz",
        desc: "Modern Android App Architecture Object-oriented programming in Java",
      },
      {
        name: "Frontend Developer Intern",
        company: "Unipe",
        desc: "Modern Android App Architecture Object-oriented programming in Java",
      },
    ],
  },
  {
    year: "2023",
    works: [
      {
        name: "Frontend Developer",
        company: "Unipe",
        desc: "Modern Android App Architecture Object-oriented programming in Java",
      },
    ],
  },
];

export const TESTIMONIALS = [
  {
    name: "Dr Sweta Bhansali",
    company: "Swab Nanosolutions Private Limited ",
    imageUri:
      "https://swabnanosolutions.com/static/media/team1.125513cd94c652720430.png",
    feedback:
      '"Satisfaction would be understatement with what mohak did for making our website. It was sheer perfection with what we wanted to come into reality from imagination and he very well took care of it, in fact we worked together with our ideas and his ideas combining to exactly have the website with what we imagined it to be. I would rather say he worked at the very professional and personal level to give us the perfect website which even our friends from India and abroad are highly impressed about"',
  },
  // {
  //   name: "John Doe",
  //   company: "Amazon Inc",
  //   imageUri: require("../assets/profile.png"),
  //   feedback:
  //     "Originally I was looking for a job as a frontend developer but I found Orion. Orion is a great place to work. The people are friendly, helpful and very knowledgeable. I recommend Orion to anyone looking for a job.",
  // },
];

export const WORKS = [
  {
    title: "PetNotch",
    titleDescription: "A social serving app !",
    service: "React js + Firebase",
    imageUri: pet_notch,
    projectLink: "https://petnotch.com/",
    tags: ["Web Design", "React JS", "All"],
  },
  {
    title: "Veer Eklavya Foundation",
    titleDescription: "A social serving app !",
    service: "React js + Firebase",
    imageUri: veer_eklavya_foundation,
    projectLink:
      "https://play.google.com/store/apps/details?id=com.matrimony_app",
    tags: ["Mobile App", "Firebase", "React Native", "All"],
  },
  {
    title: "Swab Nanosolutions",
    titleDescription: "A landing page for nanotechnology !!",
    service: "Mongo DB + Express js + Node js + React js",
    imageUri: swab_nanosolutions,
    projectLink: "https://swabnanosolutions.com",
    tags: ["Web Design", "React JS", "All"],
  },
  {
    title: "LocalFarmers",
    titleDescription: "A landing page for agriculture startup!",
    service: "React js + Api",
    imageUri: local_farmers,
    projectLink: "https://localfarmers.in",
    tags: ["Web Design", "React JS", "All"],
  },
  {
    title: "TrackVid",
    titleDescription: "A covid health care app!",
    service: "React Native + Covid Api",
    imageUri: trackvid,
    projectLink:
      "https://github.com/Mohak-Agrawal/trackvid-app/blob/main/README.md",
    tags: ["Mobile App", "React Native", "All"],
  },
  {
    title: "TicTacToe",
    titleDescription: "A fun game app!",
    service: "React Native",
    imageUri: tictactoe,
    projectLink:
      "https://play.google.com/store/apps/details?id=com.tictactoe_app",
    tags: ["Mobile App", "React Native", "All"],
  },
  {
    title: "ParamGuru",
    titleDescription: "A landing page for educational startup!",
    service: "React js + Api",
    imageUri: param_guru,
    projectLink: "https://param-guru-landing.web.app",
    tags: ["Web Design", "React JS", "All"],
  },
  {
    title: "Crypto Tracker",
    titleDescription: "A cryptocurrency tracking app !",
    service: "React js + Api",
    imageUri: crypto_tracker,
    projectLink: "https://cryptotracker-a980a.web.app/",
    tags: ["Web App", "All"],
  },
  {
    title: "Amazon Web Clone",
    titleDescription: "An E-commerce app !",
    service: "React js + Firebase",
    imageUri: amazon,
    projectLink: "https://clone-23274.web.app/",
    tags: ["Web Design", "React JS", "All"],
  },
  {
    title: "Veer Eklavya Foundation Admin",
    titleDescription: "Admin panel",
    service: "React js + Firebase",
    imageUri: vef_admin,
    projectLink: "",
    tags: ["Web App", "All"],
  },
  {
    title: "Calculator App",
    titleDescription: "Calculator using React.js",
    service: "React.js",
    imageUri: calculator,
    projectLink: "https://calculator-27500.web.app",
    tags: ["Web App", "All"],
  },
  {
    title: "Discord Clone",
    titleDescription: "A communication server app !",
    service: "React js + Firebase",
    imageUri: discord,
    projectLink: "https://discordclone-60237.web.app",
    tags: ["Web App", "All"],
  },
  {
    title: "WhatsApp Web Clone",
    titleDescription: "A messaging app !!",
    service: "Mongo DB + Express js + Node js + React js",
    imageUri: whatsapp,
    projectLink: "https://whatsappclone-1798a.web.app/",
    tags: ["Web App", "All"],
  },
];

export const BRANDS = [
  {
    name: "",
    imageUri: require("../assets/brand1.png"),
  },
  {
    name: "",
    imageUri: require("../assets/brand2.png"),
  },
  {
    name: "",
    imageUri: require("../assets/brand3.png"),
  },
  {
    name: "",
    imageUri: require("../assets/brand4.png"),
  },
  // {
  //   name: "",
  //   imageUri: require("../assets/brand1.png"),
  // },
];

export const SERVICES = [
  {
    title: "Web Development",
    imageUri: require("../assets/about01.png"),
    icon: <FaLaptopCode fontSize={"6rem"} />,
    description:
      "Embark on a digital journey with my expert web development service. I specialize in crafting dynamic and responsive websites that captivate your audience while ensuring seamless functionality across devices. From elegant portfolio sites to complex e-commerce platforms, I bring your online vision to life.",
  },
  {
    title: "UI/UX Design",
    imageUri: require("../assets/about01.png"),
    icon: <FaBrush fontSize={"6rem"} />,
    description:
      "Elevate user engagement and satisfaction with my cutting-edge UI/UX design solutions. I blend aesthetics with usability to create visually stunning and intuitive interfaces. My designs enhance user experiences, leaving a lasting impression that keeps them coming back for more.",
  },
  {
    title: "Android Development",
    imageUri: require("../assets/about01.png"),
    icon: <FaAndroid fontSize={"6rem"} />,
    description:
      "Tap into the vast Android market with my top-tier app development. Whether it's a utility, entertainment, or productivity app, I harness the power of Android's versatility to bring your ideas to fruition. My user-centric approach ensures apps that resonate and deliver value.",
  },
  {
    title: "iOS Development",
    imageUri: require("../assets/about01.png"),
    icon: <FaApple fontSize={"6rem"} />,
    description:
      "Join the iOS elite with my exceptional app development for Apple devices. I combine innovation and functionality to build apps that seamlessly integrate into the iOS ecosystem. From iPhones to iPads, I create apps that redefine user interaction and deliver a flawless experience.",
  },
];

// Flutter
// Material UI

// Vue
// Python
// Sass
// 5
// HTML5
// TS
// Typescript
// UI/UX Web Designer
// Google
// Node JS
// Graphql
// React JS
// JS
// Javascript
// CSS3
// Figma
// Git
